// extracted by mini-css-extract-plugin
module.exports = {"fadeToast":"Toast_fadeToast__1BNt-","fade":"Toast_fade__2hjJQ"};